import React, { Component } from "react";
import { connect } from 'react-redux';
import CmsSectionList from "./cmsSectionList";
// import { cmsSearch } from "../../actions/index";
import Pagination from "antd/lib/pagination";
import httpRequest from "apis/httpRequest";
import { RESOURCES_URL, CMSINFO_LINK } from "actions/types";
import { saveListPage, clearReduxPage } from "actions/index";
const size = 15;
// 单个cms的详细信息 包含分页
class CmsSection extends Component {
  state = {
    totalCount: 10,
    item: [],
    pageNumber: this.props.info.page || 1
  };
  getCmslist(page, size) {
    this.props.saveListPage(page);
    const resource = this.props.location.pathname.split("list=")[1];
    httpRequest.get(`${RESOURCES_URL}?source=${resource}&page=${page}&size=${size}`)
      .then(res => {
        let total = res.data.itemsCount || res.data.total;
        let dataItem = res.data.item || res.data.list;
        this.setState({
          totalCount: parseInt(total, 10),
          item: dataItem
        });
        window.scrollTo(0, 0);
      })
      .catch(err => {
        // console.log(err)
      });
  }
  componentDidMount() {
    const page = this.state.pageNumber
    this.getCmslist(page, size);
  }
  componentWillUnmount() {
    const { pathname } = this.props.history.location
    if (pathname.indexOf(CMSINFO_LINK) === -1) {
      this.props.clearReduxPage();
    }
  }
  render() {
    let title = "学院动态";
    if (this.props.location.state) {
      title = this.props.location.state.title;
    }
    return (
      <div style={{ background: "#fff" }}>
        {false && (
          <div className="cms-top">
            <div className="cms-top-bg" />
            <div className="cms-top-title">{title}</div>
          </div>
        )}
        <div className="cms-section">
          <CmsSectionList datas={this.state.item} sectionListTitle={title} />
          <Pagination
            total={this.state.totalCount}
            pageSize={size}
            defaultCurrent={this.state.pageNumber}
            onChange={this.getCmslist.bind(this)}
            className="gafa-pagination"
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { info } = state;
  return { info };
}

export default connect(mapStateToProps, { saveListPage, clearReduxPage })(CmsSection);

